import React from "react";
import Marquee from "react-fast-marquee";

const TICKER_ITEMS = [
  "MASTER DEBATERS",
  "FIRST TO 10 WINS",
  "AI-GENERATED MADNESS",
  "PICK YOUR FIGHTER",
  "DEFEND THE INDEFENSIBLE",
  "WIN AT ALL COSTS",
];

export const RetroMarquee = ({ direction = "left" }) => (
  <div
    data-testid="retro-marquee"
    className="bg-[#111111] text-[#FFD700] border-y-4 border-[#111111] py-2"
  >
    <Marquee speed={60} direction={direction} gradient={false}>
      {TICKER_ITEMS.concat(TICKER_ITEMS).map((t, i) => (
        <span
          key={i}
          className="font-anton uppercase text-2xl md:text-3xl mx-8 tracking-wider"
        >
          {t} <span className="text-[#FF2A54] mx-4">★</span>
        </span>
      ))}
    </Marquee>
  </div>
);
